import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/AdditionalServices/AdditionalServices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Corporater"] */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/Corporater/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/KeyFeature/keyFeature.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/SearchArea/SearchInput.mobile.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/SearchArea/SearchInput.pc.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/Tabs/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/tracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/(remote-jobs)/[lang]/remote-jobs/components/UserExperience/UserExperience.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/(remote-jobs)/[lang]/remote-jobs/images/bg.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Redirect/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Footer/common.scss");
;
import(/* webpackMode: "eager" */ "/app/app/(remote-jobs)/[lang]/remote-jobs/styles/index.mobile.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/components/common/AboutList.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Footer/components/common/DownloadApp_New.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/components/common/FriendLinks.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Footer/components/common/Partner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/components/common/RecruiterList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/components/common/SocialList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/components/Mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/components/PC/Copyright.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Footer/components/PC/RightFloatButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Footer/components/PC/SafeInformation.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
